import { React } from 'Imports';
import { Button } from 'MaterialUIComponents';
import { isEncompass } from '$Utilities/integrationPlatform';

interface IFiltersButtonProps {
    onClick: () => void;
    disabled?: boolean;
}

const styles = require('$Components/FilterComponents/Buttons/FiltersButton.scss') as {
    filtersButtonEncompass: string;
    filtersButtonGeotab: string;
};

export const FiltersButton = (props: IFiltersButtonProps) => {
    const { onClick, disabled = false } = props;

    return (
        <Button
            variant={'outlined'}
            onClick={onClick}
            disabled={disabled}
            disableRipple
            className={isEncompass ? styles.filtersButtonEncompass : styles.filtersButtonGeotab}
        >
            Filters
        </Button>
    );
};
